module.exports = __webpack_public_path__ + "static/media/quality4.b7f85fd1.webp";